import axiosInstance from "./axios/axios_instance";

const http = axiosInstance("/protected", null, "/logout");

const getAffiliateTracking = () => http.get("/track_affiliates");

export default {
    getAffiliateTracking
};
